import type { Language } from "@/Common/Models/Domain/Language";
import type { LocaleApi } from "@/Modules/i18n/Model/Api";

import { get2 } from "./utils/FunctionalTherapyApi";

export const getLocale = async (locale: Language): Promise<LocaleApi> => {
  return get2<{ locale: Language }, LocaleApi>(`/v1.0/app-translations`, { locale });
};

export const getAllLocales = async (): Promise<LocaleApi[]> => {
  return get2<null, LocaleApi[]>(`/v1.0/app-translations`);
};

export const getAllLocalesInfo = async (): Promise<Omit<LocaleApi, "translations">[]> => {
  return get2<{ short: boolean }, Omit<LocaleApi, "translations">[]>(`/v1.0/app-translations`, {
    short: true,
  });
};
